import React, { memo, type PropsWithChildren } from 'react';
import { StyleSheet } from 'react-native';

import { theme } from '@garnish/constants';
import { TitleText } from '@garnish/core';

// ─────────────────────────────────────────────────────────────────────────────

export const PermissionsPromptTitle = memo((props: PropsWithChildren) => {
  return (
    <TitleText sizeMatch={['48']} style={styles.title}>
      {props.children}
    </TitleText>
  );
});

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  title: {
    color: theme.colors.CREAM,
    marginBottom: theme.spacing['4'],
  },
});
